// src/views/menage/CarteInterventionAgent.jsx — une INTERVENTION, côté AGENT,
// d'après la maquette NEST v677 (`carteItv`, puis sa feuille `x124_itv`).
//
// ⚠️ POURQUOI UNE CARTE À PART, ET PAS `CarteMenageAgent`. Une intervention n'a
// ni checklist, ni voyageurs qui arrivent, ni « ménage terminé ».
//
// ⚠️ DEUX TEMPS, PAS DE DÉFAIRE (décision Dimitri 2026-08-12) : la base refuse
// le retour en arrière à l'agent, un pouce qui glisse est définitif. Ici le
// premier temps est « Commencer l'intervention », qui ouvre la feuille ; le
// second, « Terminer l'intervention », dans la feuille. « Faite » ne s'affiche
// que quand le serveur l'a enregistré.
//
// ⚠️ TROU (point d'arrêt base) : la feuille de la maquette exige une photo
// (« Photos · obligatoires »). Une intervention n'a nulle part où ranger une
// photo en base : à décider, pas à simuler ici.

import { useState } from "react"
import { formaterDuree, formaterHeureCourte } from "../../lib/menage-frise"
import { estFaite, heureInterventionMin, phraseFaite, SANS_HEURE } from "../../lib/menage-journee-interventions"
import { CartePlanning, PhraseCarte, LigneAcces, BoutonCarte, BoutonIncident, FeuilleAgent } from './CartePlanning'
import { NEST } from './palette-nest'

function heureTexte(intervention) {
  const min = heureInterventionMin(intervention)
  return min == null ? SANS_HEURE : formaterHeureCourte(min)
}

export default function CarteInterventionAgent({ intervention, info, habit = 'grand', onValider, onIncident, enCours = false, ancre }) {
  const [feuille, setFeuille] = useState(false)
  const faite = estFaite(intervention)
  const duree = Number(intervention?.duree_min) > 0 ? Number(intervention.duree_min) : null
  const nom = info?.nom || 'un logement'
  const code = (info?.codes_acces?.boite_cles && String(info.codes_acces.boite_cles).trim()) || null
  const sousTitre = faite ? phraseFaite(intervention)
    : ['intervention · consigne', duree ? formaterDuree(duree) : null].filter(Boolean).join(' · ')
  const terminer = async () => {
    await onValider(intervention)
    setFeuille(false)
  }

  return (
    <div ref={ancre}>
      <CartePlanning testId={`carte-intervention-${intervention.id}`} habit={habit}
        heure={heureTexte(intervention)} titre={`Intervention · ${nom}`} sousTitre={sousTitre}>
        {!faite && (<>
          <PhraseCarte testId={`intervention-libelle-${intervention.id}`}>{intervention.libelle}</PhraseCarte>
          <LigneAcces adresse={info?.adresse_complete} cp={info?.code_postal} ville={info?.ville} code={code}
            testIdGps={`intervention-gps-${intervention.id}`} testIdCode={`intervention-code-${intervention.id}`} />
          <BoutonCarte testId={`intervention-commencer-${intervention.id}`} onClick={() => setFeuille(true)}>
            Commencer l’intervention
          </BoutonCarte>
          {onIncident && <BoutonIncident testId={`intervention-incident-${intervention.id}`} onClick={() => onIncident(intervention)} />}
        </>)}
      </CartePlanning>
      {feuille && (
        <FeuilleAgent titre={`Intervention · ${nom}`} testId={`feuille-intervention-${intervention.id}`} onFermer={() => setFeuille(false)}>
          <div style={{ fontSize: 12, fontWeight: 700, color: NEST.vertFonce, textTransform: 'uppercase', letterSpacing: '.04em', margin: '4px 2px 6px' }}>À faire</div>
          <div style={{ background: NEST.fondCarte, borderRadius: 12, padding: 12, fontSize: 13, marginBottom: 12 }}>{intervention.libelle}</div>
          {(info?.adresse_complete || code) && (<>
            <div style={{ fontSize: 12, fontWeight: 700, color: NEST.vertFonce, textTransform: 'uppercase', letterSpacing: '.04em', margin: '4px 2px 6px' }}>Accès</div>
            <div style={{ background: NEST.fondCarte, borderRadius: 12, padding: 12, marginBottom: 12 }}>
              <LigneAcces adresse={info?.adresse_complete} cp={info?.code_postal} ville={info?.ville} code={code} />
            </div>
          </>)}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <BoutonCarte testId={`intervention-valider-${intervention.id}`} disabled={enCours} onClick={terminer}>
              {enCours ? 'Enregistrement…' : 'Terminer l’intervention'}
            </BoutonCarte>
            <button type="button" onClick={() => setFeuille(false)}
              style={{ minHeight: 44, borderRadius: 10, border: `1px solid ${NEST.boutonBord}`, background: '#fff', color: NEST.boutonTexte, fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>
              Plus tard
            </button>
          </div>
          <p style={{ fontSize: 11.5, color: NEST.gris, margin: '10px 2px 0' }}>« Faite » ne s’affiche que quand le serveur l’a enregistré.</p>
        </FeuilleAgent>
      )}
    </div>
  )
}
